import React from 'react';

import { ERoutes } from 'infra/routes/routes.enum';

import { useAppSelector } from 'store/hooks';

import * as selectUser from 'store/user/user.selector';

import { Container, Content } from './404.styles';

const NotFound = () => {
  const isLoggedIn = useAppSelector(selectUser.isLoggedIn);

  return (
    <Container>
      <Content>
        <h1>404</h1>
        <h2>Desculpe, esta página não está disponível.</h2>
        <p>
          Clique{' '}
          <a href={isLoggedIn ? ERoutes.Dashboard : ERoutes.SignIn}>aqui</a>{' '}
          para voltar a navegação.
        </p>
      </Content>
    </Container>
  );
};

export default NotFound;
